import type { TemplateFormLanguage } from '../types/templateForms';

export const DEFAULT_TEMPLATE_FORM_LANGUAGE: TemplateFormLanguage = 'en';
